



















import Vue from 'vue'
import Component from 'vue-class-component'
import Status from '@/components/statuses/Status.vue'

@Component({
  components: { Status },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
})
export default class Tabs extends Vue {

}
